import { useEffect, useRef, useContext, useState } from 'react';
import { TabIdsContext, TabId } from './TabProvider';
import { useUID } from 'dibs-uid';
let tabWarningLogged = false;

export const useSharedTab = (name: string, type: 'tab' | 'panel'): TabId => {
    const uid = useUID();
    const nameRef = useRef(name);
    const tabIdsContext = useContext(TabIdsContext);
    const { setTabIds, tabIds } = tabIdsContext || {};
    const [tabIdState, setTabIdState] = useState({ ...tabIds?.[name] });

    if (tabIdsContext === null && !tabWarningLogged) {
        console.warn('dibs-elements | useSharedTab | useSharedTab requires TabProvider');
        tabWarningLogged = true;
    }

    useEffect(() => {
        // register tab
        if (setTabIds && uid) {
            setTabIds((prev = {}) => {
                const newTabIds = {
                    ...prev,
                    [name]: { ...prev[name], [type]: uid },
                };
                return newTabIds;
            });
        }
        // deregister tab
        return () => {
            if (setTabIds) {
                setTabIds(prev => {
                    const newTabIds = { ...prev };
                    delete newTabIds[name];
                    return newTabIds;
                });
            }
        };
    }, [setTabIds, type, uid, name]);

    useEffect(() => {
        // monitor for changes to tabIds, update only on value change
        const newState = { ...tabIds?.[name] };
        if (
            tabIdState.panel !== newState.panel ||
            tabIdState.tab !== newState.tab ||
            name !== nameRef.current
        ) {
            setTabIdState(newState);
        }
        nameRef.current = name;
    }, [tabIds, name, tabIdState]);

    return tabIdState;
};
